module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cc-Da-Eb.20cbb5b2.png";